import React from "react";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import useIsMobile from "../../hooks/useIsMobile";
import ContinueButton from "canvas-core-react/lib/ContinueButton";

export const PrimaryButtonCustom = (props) => {
    const {text} = props;
    const isMobile = useIsMobile();
    return (
        <div className="PrimaryButtonCustom">
            {isMobile ? (
                <PrimaryButton {...props}>{text}</PrimaryButton>
            ) : (
                <ContinueButton {...props}>{text}</ContinueButton>
            )}
        </div>
    );
};
